var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 16v-2h4s-1.492 1.246-3 2c-.054.027-1 0-1 0M2.001 1.914h14V12H13c-1.875 0-2.999 1-2.999 2v1.914h-8zM14.16 17.473l3.182-2.546c.422-.337.659-.795.659-1.272V1.8C18 .806 16.992 0 15.75 0H2.25C1.008 0 0 .806 0 1.8v14.4c0 .994 1.008 1.8 2.25 1.8h10.319c.596 0 1.168-.19 1.59-.527M4 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m9 3H5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m-8 4h2a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2",
  clipRule: "evenodd"
})));
export default SvgGemNote;